/* import __COLOCATED_TEMPLATE__ from './anchor-link-copy-button.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { TextSerializer } from '@intercom/composer-core';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
let AnchorLinkCopyButton = (_class = class AnchorLinkCopyButton extends Component {
  get anchorLinkPoint() {
    return this.args.composer.state.hoverInfo?.anchorLinkPoint;
  }
  get editorRect() {
    return this.args.composer.state.hoverInfo?.editorRect;
  }
  get computedStyle() {
    if (!this.anchorLinkPoint) {
      return;
    }
    let hoveredElement = this.anchorLinkPoint.domElement;
    let offsets = this.calculateOffset(hoveredElement);
    let left = offsets.left;
    let top = offsets.top + hoveredElement.clientHeight / 2;
    return sanitizeHtml(`
      left: ${left}px;
      top: ${top}px;
      `);
  }
  calculateOffset(domElement) {
    let x = 0;
    let y = 0;
    while (!domElement.classList.contains('embercom-prosemirror-composer')) {
      x += domElement.offsetLeft;
      y += domElement.offsetTop;
      let computedStyles = getComputedStyle(domElement);
      let borderLeftWidth = Number.parseInt(computedStyles.getPropertyValue('border-left-width').replace('px', ''), 10);
      let borderTopWidth = Number.parseInt(computedStyles.getPropertyValue('border-top-width').replace('px', ''), 10);
      x += borderLeftWidth;
      y += borderTopWidth;
      domElement = domElement.offsetParent;
    }
    return new DOMRect(x, y, 0, 0);
  }
  onClick() {
    if (!this.anchorLinkPoint || !this.args.options?.onClick) {
      return;
    }
    let selectedNode = this.anchorLinkPoint.node;
    let selectedHeading = {
      type: selectedNode.attrs.type,
      text: new TextSerializer(this.args.composer.schema).serializeNode(selectedNode),
      idAttribute: selectedNode.attrs.idAttribute
    };
    this.args.options.onClick(selectedHeading);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _class);
export { AnchorLinkCopyButton as default };